const leaderboard_fields = `
			id
			event_id
			name
			start_time
			end_time
			rows
			show_stats
			show_averages
			show_members
			individual
			group_individual
			teams {
				id
			}
			sources {
				id
				event_id
				name
				type
				type_id
			}
			sources_selection
			created_at
			updated_at
`;

export const EVENT_LEADERBOARDS = `
	query eventLeaderboards($event_id: Uint) {
		eventLeaderboards(event_id: $event_id) {
			${leaderboard_fields}
		}
	}
`;

export const LEADERBOARD_SETTINGS = `
	query leaderboardSettings($id: Uint) {
		leaderboardSettings(id: $id) {
			${leaderboard_fields}
		}
	}
`;
